export const getShortTimeZoneLabel = (label) => {
    if (!label) return "";
    const source = `${label}`.trim();
    if (!source) return "";

    const doubleBracketIndex = source.indexOf(" ((GMT");
    if (doubleBracketIndex > -1) {
        return source.slice(0, doubleBracketIndex).trim() || source;
    }

    const singleBracketIndex = source.indexOf(" (");
    if (singleBracketIndex > -1) {
        return source.slice(0, singleBracketIndex).trim() || source;
    }

    return source;
};
